module.exports = __webpack_public_path__ + "img/ico_ph54-59.5070cb74.svg";